import React from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as SuccessIcon } from "../../../../assets/icons/survey-success.svg";

import "../../../../assets/survey.scss";

const SurveySuccessRender = ({ handleSurveyOk }) => {
  const { t } = useTranslation(["loginAndSignUp"]);

  return (
    <div className="step-success-cont d-flex flex-column align-items-center justify-content-center mx-auto">
      <h4 className="fw-bold text-center">{t("signUpSuccessTips")}</h4>
      <SuccessIcon />
      <Button type="primary fs-6 fw-bolder" size="large" onClick={handleSurveyOk}>
        {t("surveyStartBtn")}
      </Button>
    </div>
  );
};

export default SurveySuccessRender;
